import React from "react";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { useNavigate } from "react-router-dom";
import OptinFollowUpTable from "./OptinFollowUpTable";

const OptinFollowUp = () => {
  const {
    sideBar,
    setOptinFollow,
    setMenuTab,
    saveNewNodeAndEdges,
    saveTemplateName,
  } = useProductsContext();

  const navigate = useNavigate();

  const handleMenu = () => {
    setOptinFollow("optin");
    setMenuTab("chatbot1");
    navigate(`/dashboard/chatbot`, { state: { create: false, from: "fb" } });
    saveNewNodeAndEdges([], []);
    saveTemplateName({});
  };

  return (
    <>
      <div
        className="content-page"
        style={{
          marginLeft: sideBar ? "230px" : "120px",
          backgroundColor: "#fff",
        }}>
        <div className="content">
          <div className="container-fluid">
            <div className="row"></div>
            <div className="sec-wrapper">
              <div className="d-flex align-items-center justify-content-between mb-3 mt-2">
                <h5 className="page-title">Opt-In Follow Up Templates</h5>
                <div className="text-end">
                  <button
                    type="button"
                    onClick={handleMenu}
                    className="btn btn-primary rounded-pill new-chat">
                    <img
                      src="../assets/images/chatbot.svg"
                      className="img-fluid"
                      alt=""
                    />
                    New Opt-in Follow Up Template
                  </button>
                </div>
              </div>
              <div className="tablerounededCorner-subscriber table-responsive">
                <OptinFollowUpTable rows={[]} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OptinFollowUp;
